import { Tooltip } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { TodoTableTodo } from "../TodoTable";

function getLabelColumn(): MRT_ColumnDef<TodoTableTodo> {
  return {
    header: "Aufgabe/Pflicht",
    accessorKey: "label",
    size: 250,
    filterVariant: "multi-select",
    Cell: ({ row }) => {
      const label = row.original.label;

      return (
        <Tooltip label={label} openDelay={500}>
          <span>{label}</span>
        </Tooltip>
      );
    }
  };
}

export { getLabelColumn };
